<template>
  <multiselect
    v-validate="required && 'required'"
    :multiple="true"
    :options="options"
    :searchable="true"
    :internal-search="false"
    :option-height="104"
    :loading="isSearching"
    :options-limit="50"
    :value="gifts"
    track-by="id"
    label="title"
    placeholder="Επιλέξτε προιόν με χρήση barcode, τίτλου..."
    select-label="Πατήστε enter για επιλογή"
    deselect-label="Πατήστε enter για απο-επιλογή"
    class="multiple"
    data-vv-value-path="value"
    data-vv-name="gifts"
    @search-change="searchGifts"
    @select="selectProduct"
    @remove="removeProduct"
  >
    <template v-slot:option="props" class="option">
      <ProductPhoto
        :type="props.option.type"
        :photos="props.option.photos"
        class="option__image"
      />

      <div class="option__desc">
        <span class="option__title">{{ props.option.title }}</span>
        <span class="option__small">{{ props.option.barcode }}</span>
      </div>
    </template>
    <template v-slot:noResult>
      <span>Δε βρέθηκαν αποτελέσματα. Προσπαθήστε ξανά!!</span>
    </template>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect';
import _debounce from 'lodash/debounce';
import request from '@/utils/request';
import ProductPhoto from '@/views/components/ProductPhoto';

export default {
  inject: ['$validator'],
  components: {
    Multiselect,

    ProductPhoto,
  },
  props: {
    gifts: {
      type: [Object, Array],
      validator(value) {
        // Check if value is an array or an object
        return Array.isArray(value) || typeof value === 'object';
      },
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      options: [],
      isSearching: false,
    };
  },
  methods: {
    // eslint-disable-next-line func-names
    searchGifts: _debounce(async function(searchQuery) {
      if (searchQuery.length) {
        this.isSearching = true;
        const { data } = await request.get('/gifts-search', {
          params: {
            term: searchQuery,
          },
        });
        this.isSearching = false;

        this.options = data.gifts;
      }
    }, 300),
    selectProduct(selectedOption) {
      this.$emit('selectProduct', selectedOption);
    },
    removeProduct(selectedOption) {
      this.$emit('removeProduct', selectedOption);
    },
  },
};
</script>
